import { ClassLevelHashDict } from '@/assets/js/select';
import { LevelFilters } from '@/assets/js/status';

export function scoreFilter(val) {
  let tips = "--";
  if (!val) {
    tips = "本次未观察到";
  } else {
    switch (+val) {
      case 0:
        tips = "本次未观察到";
        break;
      case 1:
        tips = "较差";
        break;
      case 2:
        tips = "低于平均";
        break;
      case 3:
        tips = "平均水平";
        break;
      case 4:
        tips = "良好";
        break;
      case 5:
        tips = "极佳";
        break;
    }
  }
  return tips;
}

/* 处理学员运动经历，执教经历。。。这堆奇怪数据的过滤器;
  注： 返回数据可能是：空字符串，字符串'无'，JSON字符串化的二维数组
  原始代码：
          // let take_place = "";
          // if (
          //   this.info.studentSingnInfo.take_place &&
          //   this.info.studentSingnInfo.take_place !== "无"
          // ) {
          //   const temList = JSON.parse(this.info.studentSingnInfo.take_place);
          //   temList.forEach((letTmp) => {
          //     if (letTmp) {
          //       let tmp1 = letTmp[0];
          //       for (var x = 1; x < letTmp.length; x++) {
          //         if (letTmp[x]) {
          //           tmp1 = tmp1 + "/" + letTmp[x];
          //         }
          //       }
          //       take_place = take_place + tmp1 + "，";
          //     }
          //   });
          //   take_place = take_place.substr(0, take_place.length - 1);
          //   this.info.studentSingnInfo.take_place = take_place;
          // }

          // let sport_experience = "";
          // if (
          //   this.info.studentSingnInfo.sport_experience &&
          //   this.info.studentSingnInfo.sport_experience !== "无"
          // ) {
          //   try {
          //     const temList = JSON.parse(
          //       this.info.studentSingnInfo.sport_experience
          //     );
          //     temList.forEach((letTmp) => {
          //       if (letTmp) {
          //         let tmp1 = letTmp[0];
          //         for (var x = 1; x < letTmp.length; x++) {
          //           if (letTmp[x]) {
          //             tmp1 = tmp1 + "/" + letTmp[x];
          //           }
          //         }
          //         sport_experience = sport_experience + tmp1 + "，";
          //       }
          //     });
          //     sport_experience = sport_experience.substr(
          //       0,
          //       sport_experience.length - 1
          //     );
          //     this.info.studentSingnInfo.sport_experience = sport_experience;
          //   } catch (err) {
          //     console.log("err:", err);
          //   }
          // }

          // let coach_experience = "";
          // if (
          //   this.info.studentSingnInfo.coach_experience &&
          //   this.info.studentSingnInfo.coach_experience !== "无"
          // ) {
          //   const temList = JSON.parse(
          //     this.info.studentSingnInfo.coach_experience
          //   );
          //   temList.forEach((letTmp) => {
          //     if (letTmp) {
          //       let tmp1 = letTmp[0];
          //       for (var x = 1; x < letTmp.length; x++) {
          //         if (letTmp[x]) {
          //           tmp1 = tmp1 + "/" + letTmp[x];
          //         }
          //       }
          //       coach_experience = coach_experience + tmp1 + "，";
          //     }
          //   });
          //   coach_experience = coach_experience.substr(
          //     0,
          //     coach_experience.length - 1
          //   );
          //   this.info.studentSingnInfo.coach_experience = coach_experience;
          // }
 */
export function experienceFilter(val) {
   if (val) {
        if (val !== "无" && val !== '"无"' && val !== "'无'") {
          try {
            let arr = JSON.parse(val);
            let list = arr.map((item) => {
              return item.join("/");
            });
            return list.join("\n");
          } catch(err) {
            console.error('JSON String is error for unknnow reason:', val)
            return val
          }
        } else {
          return val;
        }
      } else {
        return "--";
      }
}

export function experienceFilter1(val) {
   if (val) {
        if (val !== "无" && val !== '"无"' && val !== "'无'") {
          try {
            let arr = JSON.parse(val);
            let list = arr.map((item) => {
              return item.join("/");
            });
            return list.join("，");
          } catch(err) {
            console.error('JSON String is error for unknnow reason:', val)
            return val
          }
        } else {
          return val;
        }
      } else {
        return "--";
      }
}

export function experienceFilter2(val) {
   if (val) {
        if (val !== "无" && val !== '"无"' && val !== "'无'") {
          try {
            let arr = JSON.parse(val);
            return arr.join("，");
          } catch(err) {
            console.error('JSON String is error for unknnow reason:', val)
            return val
          }
        } else {
          return val;
        }
      } else {
        return "--";
      }
}

// 资质详情
export function levelFilter(val) {
  switch (val) {
    case 'A':
      return '亚足联/中国足协A级';
    case 'B':
      return '亚足联/中国足协B级';
    case 'C':
      return '亚足联/中国足协C级';
    case 'PRO':
      return '亚足联/中国足协职业级';
    default:
      return '否'
  }
}

// 讲师等级(注意区分十一人制和五人制)
export function teacherFilter(level, userType = false) {
  if (level) {
    if (userType) {
      // 默认返回十一人制讲师等级
      return level === 'early_assistant' ? '初级助理' : level === 'early' ? '初级' : `${level}级`;
    } else {
      if (['GA', 'GB', 'GC', 'GD','F0','F1','F2'].includes(level)) {
        const res = goalkeeperLevelFilter(level);
        return res
      } else {
        return level == "E" ? "D级助理" : (Number(level) == 0 ? "职业级" : `${level}级`);
      }
    }
  } else {
    return '--'
  }
}
/**
 *
 * @param {ClassLevel} level // 当前培训班等级
 * @param {IsFiveClass} flag // 是否五人制过滤器
 */
export function classInfoBoxLevelFilter(level, flag) {
  if (flag) {
    // 处理五人制等级
    if (Object.keys(ClassLevelHashDict).includes(level)) {
      return ClassLevelHashDict[level];
    } else {
      return level;
    }
  } else {
    // 十一人制等级不做处理
    if (['GC', 'GB', 'GA'].includes(level)) {
      const dic = {
        'GA': '守门员A级',
        'GB': '守门员B级',
        'GC': '守门员C级',
      }
      return dic[level]
    } else if (['F1','F2'].includes(level)) {
      const dic = {
        'F1': '体能L1级',
        'F2': '体能L2级',
      }
      return dic[level]
    } else if (['PRO'].includes(level)) {
      const dic = {
        'PRO': '职业级',
      }
      return dic[level]
    } else {
      return level;
    }
  }
}


/**
 * 返回角色名称
 * @param {*} unitName
 * @returns
 */
export function parseUnitName(unitName) {
  if (unitName) {
    const lowerStr = unitName.toLowerCase();
    let res = '--';
    if (lowerStr.indexOf('sup') > -1) res = '技术支持';
    if (lowerStr.indexOf('sys') > -1) res = '系统管理员';
    if (lowerStr.indexOf('org') > -1) res = '机构管理员';
    if (lowerStr.indexOf('tea') > -1) res = '讲师';
    if (lowerStr.indexOf('stu') > -1) res = '学员';
    if (lowerStr.indexOf('exp') > -1) res = '学员';
    if (lowerStr.indexOf('reg') > -1) res = '报名用户';
    return res;
  } else {
    return '--';
  }
}

/**
 * 返回角色缩写
 * @param {*} unitName
 * @returns
 */
export function parseUserLevelToAbridge(unitName) {
  if (unitName) {
    const lowerStr = unitName.toLowerCase();
    let res = null;
    if (lowerStr.indexOf('sup') > -1) res = 'sup';
    if (lowerStr.indexOf('sys') > -1) res = 'sys';
    if (lowerStr.indexOf('org') > -1) res = 'org';
    if (lowerStr.indexOf('tea') > -1) res = 'tea';
    if (lowerStr.indexOf('stu') > -1) res = 'stu';
    if (lowerStr.indexOf('exp') > -1) res = 'exp';
    if (lowerStr.indexOf('reg') > -1) res = 'reg';
    return res;
  } else {
    return null;
  }
}

/* 十一人制执照列表学员类型过滤器 */
export function licenseTypeFilter(val) {
  if (!val) return ''
  let res = '';
  switch (val) {
    case 'train':
      res = '等级教练执照';
      break;
    case 'goalkeeper':
      res = '守门员教练执照';
      break;
    case 'physical':
      res = '体能教练执照';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

export function goalkeeperLevelFilter(val) {
  let res = '';
  if (!val) return '--'
  switch (val) {
    case 'GA':
      res = '守门员A级';
      break;
    case 'GB':
      res = '守门员B级';
      break;
    case 'GC':
      res = '守门员C级';
      break;
    case 'GD':
      res = '守门员C级助理';
      break;
    case 'F0':
      res = '体能L1级助理';
      break;
    case 'F1':
      res = '体能L1级';
      break;
    case 'F2':
      res = '体能L2级';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

/**
 *
 * @param {enum} type // train continue_education teacher_train
 * @param {isFive} flag // 是否是五人制
 * @returns String
 */
export function classTypeFilter(type, flag = false) {
  let tips = flag ? '五人制' : '十一人制';
  switch (type) {
    case 'train': return `${tips}教练员等级培训`; break;
    case 'continue_education': return `${tips}教练员继续教育`; break;
    case 'teacher_train': return `${tips}讲师继续教育`; break;
    case 'goalkeeper_education': return `${tips}守门员教练继续教育`; break;
    case 'physical_train': return `${tips}体能教练员等级培训`; break;
    case 'goalkeeper_train': return `${tips}守门员教练等级培训`; break;
    default: return '--'; break;
  }
}

export function classTypeFilterWithoutFlag(type, flag = false) {
  // let tips = flag ? '五人制' : '十一人制';
  let tips = '';
  switch (type) {
    case 'train': return `${tips}教练员等级培训`; break;
    case 'continue_education': return `${tips}教练员继续教育`; break;
    case 'teacher_train': return `${tips}讲师继续教育`; break;
    case 'goalkeeper_education': return `${tips}守门员教练继续教育`; break;
    case 'physical_train': return `${tips}体能教练员等级培训`; break;
    case 'goalkeeper_train': return `${tips}守门员教练等级培训`; break;
    default: return '--'; break;
  }
}

/* 处理投标管理信息相关过滤器 */
export function heightClassPlane(type) {
  switch (type) {
    case 'train': return `教练员培训`; break;
    default: return '--'; break;
  }
}
/*
                          <!--
教练员等级培训  coachRankType 存在  并且  createCoachRank<>5   并且  createCoachRank<>6
教练员继续教育培训  coachRankType 存在  并且  createCoachRank=5
讲师继续教育培训   coachRankType 存在  并且  createCoachRank=6  【目前还没有，可以先不考虑】
守门员教练等级培训  coachRankSpecialType 存在  并且  createCoachRank<>5  并且  createCoachRank<>6
守门员教练继续教育培训  coachRankSpecialType 存在  并且  createCoachRank=5
（十一人制）  通过后面的 classTheQuality 如果是 eleven    另一个值为 五人制

                           -->
 */
/* 教练员培训历程 */
export function coachHistoryFilter(itemInfo) {
  const { coachRankType, coachRankSpecialType,coachRankPhysicalType, createCoachRank, classTheQuality } = itemInfo;
  let res = '';
  if (coachRankType) {
    if (createCoachRank < 5) {
      res = '教练员等级培训';
    } else if (createCoachRank === 5) {
      res = '教练员继续教育培训';
    } else if (createCoachRank === 6) {
      res = '讲师继续教育培训';
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else if (coachRankSpecialType) {
    if (createCoachRank < 5) {
      res = '守门员教练等级培训'
    } else if (createCoachRank === 5) {
      res = '守门员教练继续教育培训'
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else if (coachRankPhysicalType) {
    if (createCoachRank < 5) {
      res = '体能教练等级培训'
    } else if (createCoachRank === 5) {
      res = '体能教练继续教育培训'
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else {
    console.warn('信息有误，缺少coachRankType字段或者coachRankSpecialType。')
    res = '--'
  }
  let levelType = coachRankType || coachRankSpecialType || coachRankPhysicalType ;
  let tips = classTheQuality === 'eleven' ? '十一人制' : '五人制'
  return `${LevelFilters(levelType)} (${tips}${res})`
}
/* 教练员培训历程 */
export function coachHistoryFilterWithNoTips(itemInfo) {
  const { coachRankType, coachRankSpecialType,coachRankPhysicalType, createCoachRank } = itemInfo;
  let res = '';
  if (coachRankType) {
    if (createCoachRank < 5) {
      res = '教练员等级培训';
    } else if (createCoachRank === 5) {
      res = '教练员继续教育培训';
    } else if (createCoachRank === 6) {
      res = '讲师继续教育培训';
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else if (coachRankSpecialType) {
    if (createCoachRank < 5) {
      res = '守门员教练等级培训'
    } else if (createCoachRank === 5) {
      res = '守门员教练继续教育培训'
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else if (coachRankPhysicalType) {
    if (createCoachRank < 5) {
      res = '体能教练等级培训'
    } else if (createCoachRank === 5) {
      res = '体能教练继续教育培训'
    } else {
      console.warn('createCoachRank数据处理有误', createCoachRank);
    }
  } else {
    console.warn('信息有误，缺少coachRankType字段或者coachRankSpecialType。')
    res = '--'
  }
  return res
}

/* 获取可用报名时间 */
/**
 *
 * @param {Number} timeStamp 时间戳
 * @param {String} outFlag 格式化时间戳
 * @returns 格式化之后的时间
 */
export function getAvaibleTimeStartForSign(timeStamp = 0, outFlag = 0) {
  if (!timeStamp) return 'time inputed is error!'
  const momentJs = require('moment');
  const resTimeStamp = momentJs(timeStamp).add(13, 'M');  //  注意假设在20-06月获取到执照，则用户只能报名21-07月（包括当月）之后的培训
  if (!outFlag) {
    return resTimeStamp.format('yyyy-MM');
  } else if (outFlag === 1) {
    return resTimeStamp;
  } else {
    return resTimeStamp.format('yyyy-MM-dd');
  }
}

export function formateTimeByMomentJs(timeStamp = 0, formateStr = '', debuggerFlag = false) {
  const momentJs = require('moment');
  if (!timeStamp) {
    debuggerFlag && (console.log('time inputed is error!'))
    return '--'
  };
  !formateStr && (formateStr = 'yyyy-MM-DD HH:mm:ss')
  return momentJs(timeStamp).format(formateStr)
}

/* 拟录取状态 */
export function adminFilters(val) {
  let res = '';
  switch (val) {
    case 'one_star':
      res = '一星';
      break;
    case 'two_star':
      res = '二星';
      break;
    case 'three_star':
      res = '三星';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

/* 审核状态 */
export function auditStatusFilter(val) {
  let res = '';
  switch (val) {
    case 'pass':
      res = '会员协会通过并推荐';
      break;
    case 'repulse':
      res = '会员协会拒绝';
      break;
    case 'systemChange':
      res = '系统变更';
      break;
    case 'perfect':
      res = '资料待完善';
      break;
    case 'through':
      res = '会员协会通过';
      break;
    case 'officialPass':
      res = '中国足协通过';
      break;
    case 'officialRepulse':
      res = '中国足协拒绝';
      break;
    default:
      res = "--";
      break;
  }
  return res;
}

/* 提交状态 */
export function auditStatusForSubmit(val) {
  let res = '';
  switch (val) {
    case 'submit_enroll':
      res = '提交';
      break;
    case 'audit_enrollMan':
    case 'audit_examMan':
    case 'audit_teacherEnroll':
      res = '审核';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

//转会申请记录
export function alterationApplyFilter(val) {
  let res = '';
  switch(val) {
    case 'register':
      res = '初始注册';
      break;
    case 'transfer':
      res = '申请变更';
      break;
    case 'adjustment':
      res = '培训变更';
      break;
    default:
      res = val;
      break;
  }
  return res;
}

export function alterationAuditFilter(val) {
  let res = '';
  switch(val) {
    case 'submit_transfer':
      res = '提交申请';
      break;
    case 'enter_org_audit':
      res = '转入审核';
      break;
    case 'leave_org_audit':
      res = '转出审核';
      break;
    case 'pass':
      res = '通过';
      break;
    case 'fail':
      res = '拒绝';
      break;
    default:
      res = val;
      break;
  }
  return res;
}

export function alterStatus(val) {
  let res = '';
  switch(val) {
    case 'Edit':
      res = '暂时保存';
      break;
    case 'Initiated':
      res = '未开始';
      break;
    case 'CoachSubmit':
      res = '教练员注册申请进行中';
      break;
    case 'EnterOrgAudit':
      res = '转入协会审核中';
      break;
    case 'LeaveOrgAudit':
      res = '转出协会审核中';
      break;
    case 'Finish':
      res = '注册窗口已结束';
      break;
    case 'Complete':
      res = '注册已完成';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
export function alterStatusForCoach(val) {
  let res = '';
  switch (val) {
    case 'EnterOrgAudit':
      res = '转入协会审核中';
      break;
    case 'EnterOrgFail':
      res = '转入协会拒绝';
      break;
    case 'LeaveOrgAudit':
      res = '转出协会审核中';
      break;
    case 'LeaveOrgFail':
      res = '转出协会拒绝';
      break;
    case 'Finish':
      res = '注册变更中';
      break;
    case 'Complete':
    case 'complete':
      res = '注册变更成功';
      break;
    case 'Edit':
      res = '暂时保存';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
export function alterStatusForCoachToStudent(val) {
  let res = '';
  switch (val) {
    case 'EnterOrgAudit':
      res = '注册变更审核中';
      break;
    case 'EnterOrgFail':
      res = '注册变更失败';
      break;
    case 'LeaveOrgAudit':
      res = '注册变更审核中';
      break;
    case 'LeaveOrgFail':
      res = '注册变更失败';
      break;
    case 'Finish':
      res = '注册变更审核中';
      break;
    case 'Complete':
    case 'complete':
      res = '注册变更成功';
      break;
    case 'Edit':
      res = '暂时保存';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
export function signLevelFilters(val) {
  if (val === 'PRO') {
    return '职业'
  } else {
    return val
  }
}

// 学员待审核级别
export function auditLevelView(val = '', isFive = false) {
  let tips = '';
  if(!val) {
    tips = '--'
  }
  if(isFive) {
    tips = val.replace('P','足球职业级').replace('初','足球初级').replace('L1','足球L1级').replace('L2','足球L2级').replace('L3','足球L3级')
  } else {
    // 表以敬意
    tips = val.replace('P','职业级').replace('A','A级').replace('B','B级').replace('C','C级').replace('D','D级').replace('初','初级').replace('中','中级').replace('高','高级')
  }

  return tips;
}


// 继续教育状态过滤
export function educationStatusFilter(val) {
  let res = '';
  switch (val) {
    case 'Edit':
      res = '未提交';
      break;
    case 'Initiated':
      res = '未开始';
      break;
    case 'Incomplete':
      res = '进行中';
      break;
    case 'Finalised':
      res = '已结束';
      break;
    case 'Complete':
      res = '已完成';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

// 继续教育学习状态过滤
export function educationLearnStatusFilter(val) {
  let res = '';
  switch (val) {
    case 'Initiated':
      res = '学习未开始';
      break;
    case 'Incomplete':
      res = '学习进行中';
      break;
    case 'Finalised':
      res = '学习已结束';
      break;
    case 'Complete':
      res = '学习已完成';
      break;
    case 'Uncomplete':
      res = '学习未完成';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
// 英语能力
export function EnglishAbilityFilter(val) {
  let res = '';
  switch (val) {
    case 'none':
      res = '无英语能力';
      break;
    case 'simple':
      res = '简单英文能力（能够识别简单词汇）';
      break;
    case 'basic':
      res = '基础英文能力（相当于大学英语四级水平）';
      break;
    case 'good':
      res = '较好的英文能力（相当于大学英语六级水平）';
      break;
    case 'best':
      res = '优秀的英语能力（能够独立沟通协作）';
      break;
    case 'very_best':
      res = '优秀的足球英文能力（能够就足球术语进行英文沟通）';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
// 报名时候培训班期数选择 过滤
export function intention_class_date_periods_filter(val) {
  let res = '--';
  if(val){
    const valList = val.split(',');
    res = '选择'+valList[0]+'（阶段一：'+valList[1];
  
    if(valList.length===3){
      const regex = /-/;
      
      if(regex.test(valList[2])) {
        res = res + "，阶段二：" + valList[2]
      }else{
        res = res + "，" + valList[2]
      }
      
    }else if(valList.length===4){
      res = res + '，阶段二：' +  valList[2]
    }
    
    if(valList[3]){
      res = res + "，" + valList[3]
    }
    
    res = res +'）';
  }
  return res;
}
// 高端培训班 预录取状态
export function confirmStatus(type) {
  let train_type = '待确认';
  switch (type) {
    case "confirmed": train_type = '已确认'; break;
    case "unconfirmed": train_type = '未确认'; break;
    case "confirm_wait": train_type = '待确认'; break;
    case "refused": train_type = '已拒绝'; break;
  }
  return train_type;
}
export function coachHoursALL(level,hoursCount) {
  let hours = 32;
  switch (level) {
    case "B":
      hours = 40;
      break;
    case "A":
      hours = 48;
      break;
    case "0":
      hours = 48;
      break;
  }
  return hours-hoursCount;
}

export function punishStatus(type) {
  let typeText = '';
  switch (type) {
    case "audit":
      typeText = "待审核";
      break;
    case "pass":
      typeText = "审核通过";
      break;
    case "repulse":
      typeText = "审核拒绝";
      break;
  }
  return typeText;
}
export function AuthenticationStatus(status) {
  let typeText = '';
  switch (status) {
    case "audit":
      typeText = "待审核";
      break;
    case "pass":
      typeText = "通过";
      break;
    case "refused":
      typeText = "拒绝";
      break;
    case "perfect":
      typeText = "待完善";
      break;
    default:
      typeText = "--";
      break;
  }
  return typeText;
}
export function AuthenticationType(status) {
  let typeText = '';
  switch (status) {
    case "TopLeague":
      typeText = "150场以上顶级职业联赛出场经历";
      break;
    case "InternationalLeague":
      typeText = "国家一线队国际A级比赛出场经历";
      break;
    case "TopLeague,InternationalLeague":
      typeText = "150场以上顶级职业联赛出场经历，国家一线队国际A级比赛出场经历";
      break;
    case "InternationalLeague,TopLeague":
      typeText = "国家一线队国际A级比赛出场经历，150场以上顶级职业联赛出场经历";
      break;
    default:
      typeText = "--";
      break;
  }
  return typeText;
}
